import { Button } from '@/components/ui/button'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseNavigationHeader,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'

import { FormErrorMessage } from '../../../../Administration/Administration.styles'

type EditCardholderNameFormValues = {
  cardHolderName: string
  comment: string
}

interface OuterProps {
  cardholderName: string
  onSubmit(values: EditCardholderNameFormValues): Promise<void>
  onClose(): void
}

const EditCardholderNameFormUI = ({
  isValid,
  isSubmitting,
  errors,
  onClose,
}: FormikProps<EditCardholderNameFormValues> & OuterProps) => {
  return (
    <FormBaseContainer>
      <Form>
        <FormBaseNavigationHeader style={{ justifyContent: 'flex-start' }}>
          <h3>Edit Cardholder Name</h3>
        </FormBaseNavigationHeader>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Cardholder Name</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field data-test='cardholder-name-field' type='text' name='cardHolderName' />
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.cardHolderName && <FormErrorMessage>{errors.cardHolderName}</FormErrorMessage>}
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Comment</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field data-test='cardholder-name-comment-field' type='text' name='comment' />
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.comment && <FormErrorMessage>{errors.comment}</FormErrorMessage>}
        </FormBaseFieldBlock>
        <FormBaseButtonContainer>
          <Button key='button' type='button' onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={isSubmitting || !isValid} key='submit' type='submit'>
            Save
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}

export const EditCardholderNameForm = withFormik<OuterProps, EditCardholderNameFormValues>({
  mapPropsToValues: ({ cardholderName }) => ({
    cardHolderName: cardholderName || '',
    comment: '',
  }),
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit({
        cardHolderName: values.cardHolderName.trim(),
        comment: values.comment.trim(),
      })
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<EditCardholderNameFormValues> = {}

    if (!values.cardHolderName?.trim()) {
      errors.cardHolderName = 'required'
    }
    if (!values.comment?.trim()) {
      errors.comment = 'required'
    }

    return errors
  },
  isInitialValid: false,
  enableReinitialize: true,
})(EditCardholderNameFormUI)
